import './ContactUs.css';
import RowOne from "./RowOne";
import RowTwo from "./RowTwo";





export default function ContactUs() {
  return (
    <section
      id="contact-us"
      className="contact-us"
    >
      <RowOne />
      <RowTwo />
    </section>
  )
}
